import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Tab, Tabs } from '@mui/material';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import RoyaltyApprovalList from '../../../components/Reconciliation/Royalty/RoyaltyApprovalList';
import LabourCessApprovalList from '../../../components/Reconciliation/LabourCess/LabourCessApprovalList';
import RoyaltyPaymentList from '../../../components/Reconciliation/Royalty/RoyaltyPaymentList';
import LabourCessPaymentList from '../../../components/Reconciliation/LabourCess/LabourCessPaymentList';
import './RoyaltyApproval.css';

const RoyaltyApproval = () => {
    const { financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [page, setPage] = useState('approve');

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    };

    const renderTabContent = () => {
        switch (page) {
            case 'approve':
                return <RoyaltyApprovalList />;
            case 'royalty_payment':
                return <RoyaltyPaymentList />;
            case 'labour_approval':
                return <LabourCessApprovalList />;
            case 'labour_payment':
                return <LabourCessPaymentList />;
            default:
                return <RoyaltyApprovalList />;
        }
    };

    return (
        <div className="royalty-approval-page">
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />

            <div className="row" style={{ padding: '10px 16px' }}>
                <div className="col-md-12">
                    <h4 style={{ color: '#28326f', margin: 0 }}>Royalty & Labour Cess</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Royalty & Labour Cess" />
                </div>
            </div>

            <div className="scheme p-3">
                <div className="royalty-approval-tabs-card card p-3">
                    <Tabs
                        value={page}
                        onChange={(_, value) => setPage(value)}
                        className="royalty-approval-tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                    >
                        <Tab label="Royalty Approval" value="approve" />
                        <Tab label="Royalty Payment" value="royalty_payment" />
                        <Tab label="Labour Cess Approval" value="labour_approval" />
                        <Tab label="Labour Cess Payment" value="labour_payment" />
                    </Tabs>

                    <Box className="royalty-approval-tab-panel">
                        {renderTabContent()}
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default RoyaltyApproval;
